import { useEffect, useState } from 'react';
import { ArrowUpCircle } from 'react-feather';

import './GoTopButton.scss';

function GoTopButton() {
	const [showGoTop, setShowGoTop] = useState(false);

	const handleShowGoTop = () => {
		const position = window.scrollY;
		setShowGoTop(position > 400 ? true : false);
	};

	useEffect(() => {
		window.addEventListener("scroll", handleShowGoTop);
	}, []);

	return showGoTop && <ArrowUpCircle
		width={36}
		height={36}
		className="position-sticky float-right go-top"
		onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
	/>
}

export default GoTopButton;
